import React from "react";
import "./css/Artist.css";
import artist1 from "../assets/artist1.png";
import artist2 from "../assets/artist2.png";
import artist3 from "../assets/artist3.png";
import AnimateInView from "./AnimateInView";

const Artist = () => {
  const artistdata = [
    {
      Title: "Master Craftsman",
      Description: "Babu Ram Dhiman",
    },
    {
      Title: "Expertise",
      Description: "30+ Years Experience",
    },
    {
      Title: "Specialization",
      Description: "Custom Woodworking",
    },
    {
      Title: "Excellence",
      Description: "Premium Quality",
    },
    {
      Title: "Craftsmanship",
      Description: "Traditional Methods",
    },
    {
      Title: "Innovation",
      Description: "Modern Designs",
    },
  ];

  const picsdata = [
    artist1,
    artist2,
    artist3
  ]

  return (
    <section className="artist-main-div1">
      <AnimateInView delay={0.2}>
        <div className="artist-main-div1-content1">
          <div>
            <div className="artist-main-div1-content1-content1-heading">
              <h1 className="artist-heading">Master Craftsman</h1>
            </div>
            <div className="artist-para">
              <p className="paragraph color-artist">
                Led by Babu Ram Dhiman, our workshop combines traditional woodworking expertise with contemporary design sensibilities. With over three decades of experience, we've mastered the art of creating bespoke wooden masterpieces that transform spaces and exceed expectations.
              </p>
            </div>
          </div>
          <div className="pics-content">
            <div className="map-artist">
              {artistdata.map((item, index) => (
                <div key={index} className="map-artist-content">
                  <h2 className="artist-para2">{item.Title}</h2>
                  <p className="artist-para2">{item.Description}</p>
                </div>
              ))}
            </div>
            <div className="map-pics">
              {picsdata.map((item, index) => (
                <div key={index} className="map-pics-content">
                  <img src={item} alt={`Dhiman Wood Works Craftsmanship ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </AnimateInView>
    </section>
  );
};

export default Artist;
